var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M6.665 2.657h1.46V.113A19 19 0 0 0 5.999 0C3.892 0 2.449 1.325 2.449 3.76V6H.125v2.844h2.324V16h2.85V8.845h2.23L7.881 6H5.298V4.04c0-.822.222-1.384 1.367-1.384"
  })));
};
export default SvgFacebook;